import SameTabLink from '@/components/common/SameTabLink';
import { legalRoutes } from '@/config/legal';

export default function TermsConditionsContent() {
  return (
    <>
      {/* INTRO SECTION */}
      <p className="mb-4 font-semibold text-red-500">
        IMPORTANT! BY ACCESSING, BROWSING, DOWNLOADING, INSTALLING AND/OR USING
        THIS WEBSITE, INCLUDING OUR PROPRIETARY E-LEARNING MANAGEMENT SYSTEM
        (Sync360) SOFTWARE APPLICATION ACCESSIBLE THEREON, OR ANY CONTENT OR
        PART THEREOF (HEREINAFTER COLLECTIVELY THE “SITE”), YOU ACKNOWLEDGE THAT
        YOU HAVE READ AND UNDERSTAND THESE TERMS OF USE (“AGREEMENT”), AND THAT
        YOU AGREE TO ACCEPT AND BE BOUND BY THIS AGREEMENT. CAREFULLY READ ALL
        OF THE FOLLOWING TERMS OF USE BEFORE PROCEEDING. ACCESSING THIS SITE IS
        THE EQUIVALENT OF YOUR SIGNATURE AND INDICATES YOUR ACCEPTANCE OF THESE
        TERMS OF USE AND THAT YOU INTEND TO BE LEGALLY BOUND BY THEM. IF YOU DO
        NOT AGREE WITH THESE TERMS AND CONDITIONS, PLEASE EXIT OUR SITE.
      </p>

      <p className="mb-4">
        Rays Sports Network Inc. (referred to herein as the “Provider”, “We”,
        “Our” and “Us”), is committed to promoting the game of sports by
        providing players, students, coaches, parents, academy officials and
        related organizations and service providers through Our website
        www.rayssportsnetwork.com, including the use of Our sports e-learning
        management system Sync360, Mobile applications, Club Management
        solutions(Club7ms.com),Venue booking systèm, a proprietary application
        software accessible thereon, and the content thereof (hereinafter
        collectively referred to as the “Site”), that provides an online service
        (the “Service”) by which You may access, browse and use the content for
        free, “pay-to-play”, or on a subscription basis.
      </p>

      <p className="mb-4">
        As used herein, the term “You” or “Participant” refers to you, the user
        and/or subscriber of the Site, whether you are an individual player,
        student, coach, parent, academy official or related organization (e.g.,
        cricket club, sports academy, indoor stadium, etc.), and if you are
        under 18 years of age, your child on whose behalf You agree to allow
        access to the Site and to use the Service.
      </p>

      {/* PURPOSE OF SITE */}
      <h2 className="text-2xl font-bold mt-8 mb-4">
        What is the Purpose of Our Site and Service?
      </h2>
      <p className="mb-4">
        By opening an account and accessing, browsing and using the content and
        features of Our Site, including the Sync360 platform, Our Site provides
        a live video conferencing tool, the ability to download and upload
        practice videos, wellness and fitness data (from physical fitness
        monitors and activity trackers to fitness). A comprehensive coaching
        workstation,designed to train and develop next-gen athletes,an
        integrated system to seamlessly connect parents, coaches, academies, and
        athletes to turn dreams into reality.Empowering sports academies and
        institutions by supporting grassroots facilities with advanced training
        and education.
      </p>
      <p className="mb-4">
        By accessing, browsing and using the content and features of Our Site
        for team management solutions, including mobile application, You will be
        provided with tools to maximize team efficiency with our team management
        solutions, streamlining team members,fans and family members onboarding,
        defining athlete roles, and fostering collaboration for enhanced
        productivity. The software also supports user access management, match
        management, sponsors management, document management ,notifications, and
        Third-Party Integrations for scoring and player stats, significantly
        enhancing the functionality and user experience.
      </p>
      <p className="mb-4">
        By accessing, browsing and using the content and features of Our Site
        for venue booking solutions, (including www.rayssportsnetwork.com, any
        Redirect URLs,mobile or customized versions and related domains and
        subdomains), and the "Services" means our proprietary
        software-as-a-service solution(s), including the Booking management,
        Rays venue application programming interfaces (APIs), Rays venue Apps,
        You will be provided with tools for sports venue management to easily
        book space in your venue online, manage schedules, fill up available
        time slots, rules-based pricing management , create custom booking
        rules, repeat bookings management. User-Friendly App accessible anytime,
        anywhere, with just a few clicks and customizable engagement ,tailored
        logins and fully customizable features for organizations, club
        management, from branding to sponsorships and for facility booking .
      </p>
      <p className="mb-4">
        Additionally, as Our Site is essentially a data driven platform, We also
        strive to fulfill the dreams of sports players and parents by absorbing
        and coalescing large volumes of historical and current data, analyzing
        and visualizing that data in near real-time.
      </p>

      {/* ELIGIBILITY */}
      <h2 className="text-2xl font-bold mt-8 mb-4">Eligibility</h2>
      <p className="mb-4">
        The content and information on the Site and available through the
        Service is provided solely for informational, instructional,
        educational, training and skill development purposes only and is
        intended for individuals of all ages. However, in order to set up an
        account and have access to the account holder’s area of the Service by
        anyone under eighteen (18) years of age, without the permission of his
        or her parent or legal guardian, is unlicensed and unauthorized and
        should not be undertaken.
        <span className="font-bold">
          {" "}
          IF YOU ARE UNDER THE AGE OF 18 YOU MUST NOT USE THE SERVICE ON THIS
          SITE WITHOUT PERMISSION OF A PARENT OR LEGAL GUARDIAN
        </span>
        . Such consent may be provided by going to the following link:{' '}
        <SameTabLink to={legalRoutes.minorConsentForm} className="text-blue-500 underline hover:text-blue-700">
          Minor&apos;s Consent Form
        </SameTabLink>
        .
      </p>

      {/* ACCOUNT & SUBSCRIPTION */}
      <h2 className="text-2xl font-bold mt-8 mb-4">
        1. Account & Subscription / Paid Services
      </h2>
      <p className="mb-4">
        (i) While browsing the main web page of Our Site does not require You to
        create an account or sign up for paid subscription services, accessing
        most of the features of Our Site and Service, will require You to
        create, open an account and sign up for our Service. We reserve the
        right to terminate your account without prior notice if, in our sole
        discretion, You engage in any conduct through the Site or the Service
        that is unlawful, harassing, obscene, lewd, defamatory, adversely
        affects the computer systems through which the Site and the Service are
        provided, or otherwise contrary to sportsmanlike principles, the vision
        of the Provider, or the guidelines on user conduct specified below. In
        consideration of your use of the Site, You agree to (a) provide
        accurate, current and complete information about You as may be prompted
        by any account registration forms on the Site (“Account Data”); (b)
        maintain the security of your password and identification; (c) maintain
        and promptly update the Account Data, and any other information You
        provide to us, to keep it accurate, current and complete; and (d) be
        fully responsible for all use of your account and for any actions that
        take place using your account. You agree not to share your username and
        password with any other person, as each account entitles only one
        Participant to access the Site and the related applicable Services.
      </p>
      <p className="mb-4">
        (ii) If You elect to access or use Our products or services that
        involves payment of a fee, whether it is a subscription, one-time
        purchase or “pay-to-play”, You agree to pay, and will be responsible for
        payment of, that fee and all taxes associated with such access or use.
        Payment will be online by credit card and/or an online payment system,
        as may be selected by Us from time to time. The prices advertised for
        subscriptions, one-time purchases or “pay-to-play” products or services
        are current at the time of display but may be changed by Us at any time.
        Any changes to the subscription prices will be effective from the date
        published and apply to all new memberships or renewals of subscriptions.
        Unless otherwise specified, all prices are advertised in Canadian
        dollars. Depending on the particular product or service, the cost may
        involve a paid annual subscription, a single one-time payment (e.g., for
        a single online session with a coach). You agree to promptly notify Us
        of any changes to the chosen payment method. You will also be
        responsible for all applicable taxes, and all subscriptions purchased by
        You.
      </p>
      <p className="mb-4">
        (iii) You acknowledge that, subject to Us refunding any payment received
        from You and to the extent permitted by law, You have no right or claim
        against Us for any loss, damage, cost or expense arising from Our
        cancellation or rejection of any subscription for a product or service.
      </p>

      {/* FITNESS WARRANTY */}
      <h2 className="text-2xl font-bold mt-8 mb-4">
        2. Warranty of Sufficient Physical Fitness
      </h2>
      <p className="mb-4">
        If an individual, You represent and warrant that You (or your child, as
        applicable) are in sufficiently good physical condition to engage in the
        strenuous physical activity involved with playing competitive sports, or
        to engage in any of the activities promoted by the Site or the Service.
        All of the information provided on the Site is for informational,
        instructional, educational, training and skill development purposes
        only. You further represent and warrant that You (or your child, as
        applicable) have consulted with a qualified physician who has determined
        that You (or your child, as applicable) are in sufficient form to engage
        in the strenuous physical activity involved with playing competitive
        sports. In no event shall the Provider or any individual or company
        involved with the Provider be liable for special, indirect, incidental
        or consequential damages of any nature, including but not limited to
        personal injury arising from the Service. IF YOU (OR YOUR CHILD, AS
        APPLICABLE) ARE NOT IN SUFFICIENT PHYSICAL CONDITION TO ENGAGE IN THE
        STRENUOUS PHYSICAL ACTIVITY INVOLVED WITH PLAYING COMPETITIVE SPORTS OR
        IN UNDERTAKING THE ACTIVITIES PROMOTED BY THE SITE OR THE SERVICE, YOU
        (OR YOUR CHILD, AS APPLICABLE) SHOULD NOT ENGAGE IN THE ACTIVITIES
        DEMONSTRATED ON THE SITE.
      </p>

      {/* PROPRIETARY RIGHTS */}
      <h2 className="text-2xl font-bold mt-8 mb-4">
        3. Proprietary Rights in Site Content; Limited License
      </h2>
      <p className="mb-4">
        All content on the Site and available through the Service, including
        designs, text, graphics, pictures, video, information, applications,
        software, music, sound and other files, and their selection and
        arrangement (hereinafter called the “Site Content”), are the proprietary
        property of the Provider, its users or its licensors with all rights
        reserved. Under no circumstances will You acquire any ownership rights
        or other interest in any Site Content by or through your use of this
        Site. Except as stated herein, no Site Content may be modified, copied,
        distributed, framed, reproduced, republished, downloaded, scraped,
        displayed, posted, transmitted, or sold in any form or by any means, in
        whole or in part, without the Provider’s prior written permission. You
        may not upload or republish Site Content on any Internet, Intranet or
        Extranet site or incorporate the information in any other database or
        compilation, and any other use of the Site Content is strictly
        prohibited. Such license is subject to these Terms of Use and does not
        permit use of any data mining, robots, scraping or similar data
        gathering or extraction methods. Any use of the Site or the Site Content
        other than as specifically authorized herein, without the prior written
        permission of Provider, is strictly prohibited and will terminate the
        license granted herein. Such unauthorized use may also violate
        applicable laws including copyright and trademark laws and applicable
        communications regulations and statutes. Unless explicitly stated
        herein, nothing in these Terms of Use shall be construed as conferring
        any license to intellectual property rights, whether by estoppel,
        implication or otherwise. This license is revocable at any time without
        notice and with or without cause.
      </p>

      {/* TRADEMARKS */}
      <h2 className="text-2xl font-bold mt-8 mb-4">
        4. Trademarks and Copyright
      </h2>
      <p className="mb-4">
        (i) The copyright in all material provided on this Site is held by the
        Provider or by the original creator of the material, as the case may be.
        Except as stated herein, none of the material may be copied, reproduced,
        distributed, republished, translated, downloaded, displayed, posted,
        communicated to the public by telecommunication or transmitted in any
        form or by any means, including, but not limited to, electronic,
        mechanical, photocopying, recording, or otherwise, without the prior
        written consent of Provider or the copyright owner. Consent is granted
        to display and download the materials on this Site for your personal,
        non-commercial use only provided You do not modify the materials and
        that You retain all copyright and other proprietary notices contained in
        the materials. You also may not, without Provider’s consent, “mirror”
        any material contained on this Site on any other server. The foregoing
        consent terminates automatically if You breach any of the Terms of Use.
        Upon termination, You will immediately destroy any downloaded and
        printed materials.
      </p>
      <p className="mb-4">
        (ii) The trademarks, service marks, logos and graphics (collectively the
        “Trademarks”) used or appearing on this Site are the registered and
        unregistered trademarks of Provider, its subsidiaries or others. Other
        product names used on or in materials contained on this Site are for
        identification purposes only and may be trademarks of their respective
        companies. No license or right is granted by implication, or any other
        means to use any trademark appearing on this Site.
      </p>
      <p className="mb-4">
        (iii) Any unauthorized use of any material contained on this Site may
        violate copyright laws, trademark laws, the laws of privacy and
        publicity, and communications regulations and statutes
      </p>
      {/* USER CONDUCT */}
      <h2 className="text-2xl font-bold mt-8 mb-4">
        5. User Conduct & Restrictions On Use
      </h2>
      <p className="mb-4">
        You understand that the Service and the Site are available for your
        personal, non-commercial use only except the Provider agreed in writing
        . You agree that You will not:
      </p>
      <p className="mb-4">
        (i) ​distribute the Site Content for any purpose including, without
        limitation, compiling an internal database, redistributing or
        reproduction of the Site Content by the press or media or through any
        commercial network, cable or satellite system; or
      </p>
      <p className="mb-4">
        (ii) ​create derivative works of, reverse engineer, decompile,
        disassemble, adapt, translate, transmit, arrange, modify, copy, bundle,
        sell, sub-license, export, merge, transfer, adapt, loan, rent, lease,
        assign, share, outsource, host, publish, make available to any person or
        otherwise use, either directly or indirectly, the Site Content in whole
        or in part, in any form or by any means whatsoever, be they physical,
        electronic or otherwise. You shall not permit, allow or do anything that
        would infringe or otherwise prejudice the proprietary rights of
        Provider, or third parties or allow any other party to access the Site
        Content. The restrictions set out in this Agreement shall not apply to
        the limited extent the restrictions are prohibited by applicable law.
      </p>
      <p className="mb-4">
        (iii) use any device, software or technique to interfere with or attempt
        to interfere with the proper working of this Site.
      </p>
      <p className="mb-4">
        (iv) post or send to the Site any unlawful, fraudulent, inappropriate,
        offensive, racist, hateful, sexist, pornographic, false, misleading,
        infringing, defamatory, harassing, libellous or obscene information of
        any kind.
      </p>
      <p className="mb-4">
        (v) post or send to the Site any information that contains a virus, bug
        or other harmful item.
      </p>
      <p className="mb-4">
        (vi) use any device or technology to provide repeated automated attempts
        to access password-protected portions of this Site.
      </p>
      <p className="mb-4">
        (vii) Use the Site, if you are under the age of 18, unless You have
        first obtained the consent of your parent or legal guardian.
      </p>
      <p className="mb-4">
        (viii) Upload, post or otherwise transmit any unsolicited or
        unauthorized advertising, promotional materials, junk mail, spam, chain
        letters, pyramid schemes or any other form of solicitation (commercial
        or otherwise) through the Site or our products and services;
      </p>
      {/* PASSWORD PROTECTION */}
      <h2 className="text-2xl font-bold mt-8 mb-4">
        6. Password-Protected Areas
      </h2>
      <p className="mb-4">
        You agree to keep your user login credentials confidential, to notify
        the Provider in writing within 24 hours if your login credential is
        compromised. Unauthorized individuals attempting to access these areas
        of the Site may be subject to prosecution.
      </p>

      {/* SUBMISSIONS */}
      <h2 className="text-2xl font-bold mt-8 mb-4">
        7. Submissions or Uploaded Content
      </h2>
      <p className="mb-4">
        (ii) By submitting or uploading to Our Site any of your own information
        or content, including any stories, photographs, videos etc. (your
        “Submission”), You grant us a royalty-free, perpetual, irrevocable,
        non-exclusive and fully sublicensable right and license to use, display,
        reproduce and modify in any manner whatsoever your Submission (in whole
        or part) anywhere as We see fit. You also waive any moral rights You may
        have in your Submission.
      </p>
      <p className="mb-4">
        (iii) By making your Submission to Us, You warrant that the information
        and material You submit is true and accurate, relates only to lawful
        activity, does not infringe or violate any third party’s rights,
        including copyrights or trademark rights, nor will it be defamatory,
        false, misleading or in any manner harmful to any person or otherwise
        unlawful if posted on our Site. We reserve the right to edit, modify,
        remove from the Site or not post any material We find inappropriate for
        any reason whatsoever, without notice to any person.
      </p>
      <p className="mb-4">
        (iv) Although We take great care in posting information on Our Site,
        technical, typographic and/or photographic errors may occur in Our
        posting of your Submission. Although We request that You notify Us of
        any such errors, We are not responsible or liable under any
        circumstances for any loss or damage caused by such errors.
      </p>
      <p className="mb-4">
        (v) By submitting information to Us, You are agreeing that You will
        indemnify and hold Us, and Our affiliates, officers, directors,
        employees, consultants and agents, harmless from any claim or demand,
        including reasonable lawyers' fees, made by any person due to or arising
        directly or indirectly in any manner from your Submission to Our Site.
      </p>
      <p className="mb-4">
        (vi) By submitting information to Us, You waive all confidentiality in
        the submitted information and You acknowledge that We have no obligation
        to keep any of the submitted information confidential for any purpose.
        You also acknowledge that We can use the information in any manner We
        see fit, including publishing the information on Our Site, and elsewhere
        without compensation to You. You are prohibited from submitting any
        confidential information to Us and We will not be responsible for any
        damages to You or any third party suffered as the result of any
        unauthorized transmission of confidential information that You may make
        to or through Us or for any errors or any changes made to such
        transmitted information.
      </p>

      {/* VIRUSES */}
      <h2 className="text-2xl font-bold mt-8 mb-4">8. Computer Viruses</h2>
      <p className="mb-4">
        While every effort is made to ensure that all Site Content on this Site
        does not contain computer viruses, You should take reasonable and
        appropriate precautions to scan for computer viruses and should ensure
        that You have a complete and current backup of the applicable items of
        information contained on your computer system. You should pay specific
        attention to some of the newer viruses that have been written to
        automatically execute when an infected word processing document is
        loaded into certain word processing programs.
      </p>

      {/* SITE MAINTENANCE */}
      <h2 className="text-2xl font-bold mt-8 mb-4">9. Site Maintenance</h2>
      <p className="mb-4">
        The Site and the Service may be temporarily unavailable from time to
        time for maintenance or other reasons. We assume no responsibility for
        any error, omission, interruption, deletion, defect, delay in operation
        or transmission, communications line failure, theft or destruction or
        unauthorized access to, or alteration of, your communications. The
        Provider is not responsible for any technical malfunction or other
        problems of any telephone network or service, computer systems, servers
        or providers, computer or mobile phone equipment, software, failure of
        email or Participants on account of technical problems or traffic
        congestion on the Internet or at the Site or combination thereof,
        including injury or damage to your or to any other person’s computer,
        mobile phone, or other hardware or software, related to or resulting
        from using or downloading materials in connection with the web and/or in
        connection with the Service.
      </p>

      {/* LIMITATIONS OF LIABILITY */}
      <h2 className="text-2xl font-bold mt-8 mb-4">
        10. Limitations on Liability and Disclaimers
      </h2>
      <p className="mb-4">
        (i) ​THERE IS NO GUARANTEE THAT PERSONAL INFORMATION ON THIS SITE OR ON
        THE INTERNET WILL BE MAINTAINED CONFIDENTIAL AND SECURE. THE USE OF THIS
        SITE AND THE SITE CONTENT IS AT YOUR OWN RISK AND PROVIDER ASSUMES NO
        LIABILITY OR RESPONSIBILITY PERTAINING TO THE SITE CONTENT, YOUR USE OF
        THE SITE OR THE RECEIPT, STORAGE, TRANSMISSION OR OTHER USE OF YOUR
        PERSONAL INFORMATION.
      </p>
      <p className="mb-4">
        (ii) ​ALTHOUGH THIS SITE CONTAINS INFORMATION OBTAINED FROM OR BASED
        UPON SOURCES BELIEVED TO BE RELIABLE AND HAS BEEN PREPARED IN GOOD FAITH
        AND WITH ALL REASONABLE CARE, THIS SITE AND ALL SITE CONTENT, PRODUCTS,
        SERVICES AND SOFTWARE ON THIS SITE OR MADE AVAILABLE THROUGH THIS SITE
        ARE PROVIDED “AS IS” WITHOUT ANY REPRESENTATIONS, WARRANTIES, GUARANTEES
        OR CONDITIONS, OF ANY KIND, WHETHER EXPRESS OR IMPLIED, STATUTORY OR
        OTHERWISE, INCLUDING BUT NOT LIMITED TO, WARRANTIES AS TO UNINTERRUPTED
        OR ERROR FREE OPERATION, AVAILABILITY, ACCURACY, COMPLETENESS,
        CURRENTNESS, RELIABILITY, TIMELINESS, LEGALITY, SUITABILITY, PRIVACY,
        SECURITY, MERCHANTABILITY, QUALITY, TITLE, NON-INFRINGEMENT OR FITNESS
        FOR A PARTICULAR PURPOSE, OR THOSE ARISING OUT OF A COURSE OF DEALING OR
        USAGE OF TRADE. SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF IMPLIED
        WARRANTIES, SO THE ABOVE EXCLUSION MAY NOT APPLY TO YOU.
      </p>
      <p className="mb-4">
        (iii) IN NO EVENT WILL PROVIDER, ITS AFFILIATES, AGENTS, LICENSORS,
        SUPPLIERS, OR THEIR RESPECTIVE DIRECTORS, OFFICERS OR EMPLOYEES BE
        LIABLE TO YOU FOR ANY SPECIAL, INDIRECT, INCIDENTAL, PUNITIVE,
        EXEMPLARY, AGGRAVATED, ECONOMIC OR CONSEQUENTIAL DAMAGES, HOWSOEVER
        CAUSED, RESULTING FROM YOUR USE OF OR RELIANCE ON THIS SITE, OR ANY
        OTHER HYPERLINKED WEBSITE, INCLUDING BUT NOT LIMITED TO: DAMAGES FOR
        LOSS OF USE, LOST PROFITS OR LOST SAVINGS, EVEN IF PROVIDER OR ANY OF
        ITS LAWFUL AGENTS OR EMPLOYEES HAVE BEEN ADVISED OF THE POSSIBILITY OF
        SUCH DAMAGES OR CLAIM. IN NO EVENT WILL WE BE LIABLE FOR ANY ERRORS IN
        PROCESSING OF YOUR CREDIT CARD INFORMATION UNDERTAKEN BY ANY THIRD-PARTY
        PROVIDER WITH WHOM WE CONTRACT TO PROVIDE SUCH SERVICES.
      </p>
      <p className="mb-4">
        (iv) ​IN NO EVENT WILL PROVIDER, ITS AFFILIATES, AGENTS, LICENSORS,
        SUPPLIERS, OR THEIR RESPECTIVE DIRECTORS, OFFICERS OR EMPLOYEES, BE
        LIABLE FOR DAMAGES OR LOSSES RESULTING FROM: VIRUSES, DATA CORRUPTION,
        FAILED MESSAGES, TRANSMISSION ERRORS OR PROBLEMS; TELECOMMUNICATIONS
        SERVICE PROVIDERS; LINKS TO THIRD-PARTY WEBSITES; THE INTERNET BACKBONE;
        PERSONAL INJURY; THIRD-PARTY CONTENT, PRODUCTS OR SERVICES; DAMAGES OR
        LOSSES CAUSED BY YOU, OR YOUR RESPECTIVE EMPLOYEES, AGENTS OR
        SUBCONTRACTORS; LOSS OF USE OR LACK OF AVAILABILITY OF FACILITIES
        INCLUDING COMPUTER RESOURCES, ROUTERS AND STORED DATA; THE USE OR
        INABILITY TO USE THIS SITE OR THE SITE CONTENT; ANY OTHER WEBSITE
        ACCESSED TO OR FROM THIS SITE; OR EVENTS BEYOND THE REASONABLE CONTROL
        OF PROVIDER, EVEN IF PROVIDER OR ANY OF ITS LAWFUL AGENTS, OR EMPLOYEES
        HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES OR CLAIM.
      </p>
      <p className="mb-4">
        (v) ​THE SITE CONTENT MAY BE CHANGED WITHOUT NOTICE TO YOU. PROVIDER IS
        NOT RESPONSIBLE FOR ANY SITE CONTENT THAT YOU MAY FIND UNDESIRABLE OR
        OBJECTIONABLE. PROVIDER DISCLAIMS ANY LIABILITY FOR UNAUTHORIZED USE OR
        REPRODUCTION OF ANY PORTION OF THE SITE.
      </p>

      {/* THIRD PARTY */}
      <h2 className="text-2xl font-bold mt-8 mb-4">
        11. Third Party Websites and Content
      </h2>
      <p className="mb-4">
        The Site may provide links to other websites, servers or resources
        maintained by other organizations. Because We have no control over such
        sites, servers and resources, You acknowledge and agree that We are not
        responsible for the availability of such external sites or resources,
        and do not endorse and are not responsible or liable for any content,
        advertising, products, or other materials on or available from such
        sites or resources. Other websites may provide links to the Site with or
        without our authorization. We have no control over websites that provide
        links to the Site, and You acknowledge and agree that We do not
        necessarily endorse such websites and are not responsible for any links
        from those websites to the Site or for any content, advertising,
        products, or other materials available on such other websites. You
        further acknowledge and agree that We shall not be responsible or
        liable, directly or indirectly, for any damage or loss caused or alleged
        to be caused by or in connection with the use of or inability to use (i)
        any sites, servers or resources that We provide links to or that provide
        links to the Site, or (ii) any content, goods, or services available on
        or through any such sites, servers or resources. We shall have the
        right, at any time and in our sole discretion, to block links through
        technological or other means, without prior notice.
      </p>

      {/* PRIVACY */}
      <h2 className="text-2xl font-bold mt-8 mb-4">12. Your Privacy</h2>
      <p className="mb-4">
        Your privacy is important to Us, and We take certain steps to ensure
        your personally identifiable information is protected in compliance with
        applicable law. You hereby agree and accept the terms of Our Privacy
        Policy, as amended from time to time, which can be found at the
        following link:{' '}
        <SameTabLink to={legalRoutes.privacyPolicy} className="text-blue-600 underline hover:text-blue-800">
          Privacy Policy
        </SameTabLink>
        .
      </p>

      {/* TERMINATION */}
      <h2 className="text-2xl font-bold mt-8 mb-4">13. Termination</h2>
      <p className="mb-4">
        (i) ​This Agreement is effective until terminated by Provider, with or
        without cause, in Provider’s sole and unfettered discretion, subject to
        the terms and conditions contained in any applicable agreements between
        You and Provider. Provider may terminate this Agreement without notice
        to You if You fail to comply with any of its terms. Any such termination
        by Provider shall be in addition to and without prejudice to any other
        rights and remedies that may be available to Provider, including an
        injunction and other equitable remedies.
      </p>
      <p className="mb-4">
        (ii) ​The disclaimers, limitations on liability, ownership, termination,
        interpretation, your warranty and the indemnity provisions of this
        Agreement shall survive the termination or expiry of this Agreement.
      </p>

      {/* INDEMNITY */}
      <h2 className="text-2xl font-bold mt-8 mb-4">14. Indemnity</h2>
      <p className="mb-4">
        You agree at all times to indemnify, defend and hold harmless Provider,
        its agents, suppliers, affiliates and their respective directors,
        officers and employees, to the maximum extent permitted by law, against
        all actions, proceedings, costs, claims, damages, demands, liabilities
        and expenses whatsoever (including legal and other fees and
        disbursements) sustained, incurred or paid by Provider directly or
        indirectly in respect of:
      </p>
      <p className="mb-4">
        (i) ​any information or other content You provide on or through this
        Site or which is sent to Provider by e-mail or other correspondence; or
      </p>
      <p className="mb-4">
        (ii) ​Your use or misuse of the Site Content or this Site, including
        without limitation infringement claims.{" "}
      </p>

      {/* GOVERNING LAW */}
      <h2 className="text-2xl font-bold mt-8 mb-4">15. Governing Law</h2>
      <p className="mb-4">
        The Provider, this Site and the Site Content (excluding linked websites
        or its content) are physically located within the Province of Ontario,
        Canada. This Agreement will be governed by the laws of the Province of
        Ontario, and the laws of Canada applicable therein, and shall be treated
        in all respects as an Ontario contract, without reference to the
        principles of conflicts of law.
      </p>

      {/* INTERPRETATION */}
      <h2 className="text-2xl font-bold mt-8 mb-4">16. Interpretation</h2>
      <p className="mb-4">
        The division of this Agreement into sections and the insertion of
        headings are for convenience of reference only and shall not affect the
        construction or interpretation of this Agreement. In this Agreement,
        words importing the singular number include the plural and vice versa,
        words importing gender include all genders; and words importing persons
        include individuals, sole proprietors, partnerships, corporations,
        trusts and unincorporated associations.
      </p>

      {/* NO WAIVER */}
      <h2 className="text-2xl font-bold mt-8 mb-4">17. No Waiver</h2>
      <p className="mb-4">
        The failure of Provider to exercise or enforce any right or provision of
        these Terms of Use shall not constitute a waiver of such right or
        provision in that or any other instance.
      </p>

      {/* SEVERABILITY */}
      <h2 className="text-2xl font-bold mt-8 mb-4">18. Severability</h2>
      <p className="mb-4">
        Any provision of this Agreement which is prohibited or unenforceable in
        any jurisdiction shall, as to that jurisdiction, be ineffective to the
        extent of such prohibition or unenforceability and shall otherwise be
        enforced to the maximum extent permitted by law, all without affecting
        the remaining provisions of this Agreement or affecting the validity or
        enforceability of such provision in any other jurisdiction.
      </p>

      {/* ENUREMENT */}
      <h2 className="text-2xl font-bold mt-8 mb-4">19. Enurement</h2>
      <p className="mb-4">
        This Agreement shall inure to the benefit of and be binding upon each of
        Us and our respective successors and permitted assigns. You acknowledge
        having read this Agreement before accepting it, having the authority to
        accept this Agreement and having received a copy of this Agreement.
      </p>

    </>
  );
}
